import React, { useEffect, useState } from "react";
import { RiSendPlaneFill } from "react-icons/ri";
import { TfiClose } from "react-icons/tfi";
import { PiEyeFill } from "react-icons/pi";
import useAppNavigation from "../../../../hooks/useAppNavigation";
import { screens } from "../../../../constants";
import EndStreamModal from "../../../../components/endStreamModal";
import {
  callCreateStreamAPI,
  callCreateTokenAPI,
  callEndStreamAPI,
  callGetRTMToken,
  callEvent,
} from "../../../../services/main.service";
import {
  startRecordingData,
  stopRecordingData,
} from "../../../record-video/record-video.action";
import {
  stopRecordAPI,
} from "../../../../services/record.service";
import {
  setCreateStreamData,
  setTokenData,
  setRTMToken,
  setHostTime,
  setStramState,
  setHostSeconds,
} from "../../../live-main/livemain.actions";
import { showIsAttendeeList, turnOffScreenSharing, turnOffRecord } from "../streamControls/controls.actions";
import useAppDispatch from "../../../../hooks/useAppDispatch";
import { useParams } from "react-router-dom";
import axios from "axios";
import useAppAccessor from "../../../../hooks/useappAccessor";
import { toast } from "react-toastify";
import { REACT_APP_ENV } from "../../../../config";
import EndStreamModalHost from "../../../../components/endStreamModalFromHost";
import { isEmpty } from 'lodash';

const HeaderControls = (props: any) => {
  const { navigate } = useAppNavigation();
  const [isGoLive, setIsGoLive] = useState(false);
  const [isEndStream, setIsEndStream] = useState(false);
  const [isEndStreamHost, setIsEndStreamHost] = useState(false);
  const [time, setTime] = useState(0);
  const [dnLink, setDnLink] = useState("");
  const [linkVisible, setLinkVisible] = useState(false);
  const dispatch = useAppDispatch();
  const { getLiveMainData, getControls, getUserData, getInteractions} = useAppAccessor();
  const { interactionData } = getInteractions();
  const { language, user } = getUserData();
  const { publicUserData } = user;
  const { hostTime, personNum, streamState } = getLiveMainData();
  const { showAttendeeCount, isRecord } = getControls();
  const key = "AIzaSyC8C7wUGCVSnCsmAwrheAB2Tp4a2sDK0PI";
  const { id } = useParams();
  var resp1 = {
    "metadata": {
        "attendees": [
            {
                "attendee_id": "repsites|marketamer-943788",
                "connection_id": "",
                "created_at": "Thu, 13 Jun 2024 10:46:49 GMT",
                "email": "100100454zz@yopmail.com",
                "family_name": "T",
                "flags": {
                    "active": false,
                    "banned": false,
                    "connected": true,
                    "is_host": true,
                    "login_attempts": 0
                },
                "given_name": "Market",
                "issuer_metadata": {},
                "joined_at": null,
                "left_at": null,
                "role": "host",
                "stream_vendor_user_id": 436570227
            }
        ],
        "configuration": {
            "authentication": {
                "stream_password": null
            },
            "description": "",
            "display_language": "en_US",
            "interaction_library": [],
            "limits": {
                "maximum_attendees": 250,
                "maximum_presenters": 3,
                "maximum_streams_per_day": 25,
                "maximum_time_per_stream": 60
            },
            "locale": "en_US",
            "options": {
                "attendee": {
                    "enable_2fa": false,
                    "enable_camera": false,
                    "enable_chat": false,
                    "enable_microphone": true,
                    "enable_multiple_hosts": false,
                    "enable_password": false,
                    "enable_private_messages": false
                },
                "host": {
                    "enable_camera": false,
                    "enable_microphone": false
                }
            },
            "region": "america",
            "stream_id": 10000046073,
            "stream_secret": "e101505d-be6a-4172-b95c-5f5b6dab39f5",
            "stream_slug": "",
            "title": ""
        },
        "flags": {
            "active": false,
            "connected": false,
            "recording": false
        },
        "interactions": [],
        "messages": [],
        "metrics": {
            "created_at": "Thu, 13 Jun 2024 10:46:49 GMT",
            "ended_at": null,
            "started_at": null
        },
        "recordings": [],
        "servers": null,
        "stream_instance_id": "1902bb70-03f7-4f60-8a86-dcd88206ddcb"
    },
    "owner": {
        "client_id": "repsites",
        "user_id": "marketamer-943788"
    },
    "schema_version": 1,
    "stream_id": 10000046073,
    "stream_instance_id": "1902bb70-03f7-4f60-8a86-dcd88206ddcb"
};

  const isHost = () => {
    return window.location.href.indexOf("/stream") > -1 || window.location.href.indexOf("/endLive") > -1;
  };

  const formatTime = (time: number) => {
    const hours = Math.floor(time / 3600);
    const minutes = Math.floor((time % 3600) / 60);
    const seconds = time % 60;

    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
      2,
      "0"
    )}`;
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(dnLink);
    setLinkVisible(false);

    toast(`Link copied to clipboard.`, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  };

  const extractDomainUrl = () => {
    // Get the current window location and return origin with trailing slash
    return `${window.location.origin}/`;
  };

  const generateDynamicLink = async () => {
    if (linkVisible) {
      setLinkVisible(false);
    } else {
      var refererInfo = null;
      const search = window.location.search;
      const params = new URLSearchParams(search);
      refererInfo = params.get("referrer_token");
      if (refererInfo) {
        var link: any = await axios.post(
          `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${key}`,
          {
            dynamicLinkInfo: {
              domainUriPrefix: "https://liveverb.page.link",
              link: extractDomainUrl() + id+"?referrer_token="+refererInfo,
              iosInfo: {
                iosBundleId: "com.verb.golive",
              },
            },
          }
        );
      } else {
        var link: any = await axios.post(
          `https://firebasedynamiclinks.googleapis.com/v1/shortLinks?key=${key}`,
          {
            dynamicLinkInfo: {
              domainUriPrefix: "https://liveverb.page.link",
              link: extractDomainUrl() + id,
              iosInfo: {
                iosBundleId: "com.verb.golive",
              },
            },
          }
        );
      }


      if (link.status == 200) {
        link = link.data.shortLink;
        setDnLink(link);
        props.handleShareClick(link);

        // setLinkVisible(true);
      }

     // console.log("Dynamic link:", link);
    }
  };

  const handleCreateStream = () => {
    props.loaderMessageTxt(language['creating_stream']);
    props.loaderStatus(true);

    // for stream
    callCreateStreamAPI()
      .then((resp: any) => {
        dispatch(setCreateStreamData(resp));
        resp1 = resp;
        callEvent([{
          "event_data":
          {"client_id":resp["owner"]['client_id'],
            "stream_id":resp["stream_id"],
            "stream_instance_id":resp["stream_instance_id"],
            "user_id":resp["owner"]['client_id'],
            "elapsed_seconds":"0",
            "date":new Date().toUTCString()},
          "event_type":"stream_started"}
        ]);
       // console.log("CreateStream=====>", resp);
        try {
          callEvent([{"event_data":
            {"attendee_email":resp1['metadata']['attendees'][0].email,
              "attendee_first":resp1['metadata']['attendees'][0].given_name,
              "attendee_id":resp["attendee_id"],
              "attendee_role":resp["role"],
              "attendee_last":resp1['metadata']['attendees'][0].family_name+" (host)",
              "client_id":resp['owner']['client_id'],
              "stream_id":props.roomId,
              "stream_instance_id":resp["stream_instance_id"],
              "user_id":resp['owner']['user_id'],
              "max_presenters":3,
              "elapsed_seconds":"0",
            "date":new Date().toUTCString()},
            "event_type":"camera_started"}]);
        } catch (error) {
         // console.log(error);
        }
        
        handleGetToken(
          resp["stream_instance_id"],
          resp["metadata"]["attendees"][0]["stream_vendor_user_id"] ?? 0
        );

      })
      .catch((err) => {
        props.loaderStatus(false);
       // console.log("streamData====>Err", err);
      });

    // for chat
    callGetRTMToken("", true)
      .then((resp) => {
        dispatch(setRTMToken(resp));
       // console.log("RTMToken=====>", resp);
      })
      .catch((err) => {
       // console.log("RTMToken====>Err", err);
      });
  };

  const handleGetToken = (
    stream_instance_id: string,
    stream_vendor_user_id: number
  ) => {
    callCreateTokenAPI(stream_instance_id, stream_vendor_user_id)
      .then((resp) => {
        dispatch(setTokenData(resp));
        dispatch(setStramState("started"));
        setIsGoLive(true);
        props.loaderStatus(false);
      })
      .catch((err) => {
        props.loaderStatus(false);
       // console.log("streamData====>Err", err);
      });
  };

  const handleEndStream = () => {
    setIsEndStream(false);
    if (isHost() ) {
      props.loaderMessageTxt(language['ending_stream_wait']);
      props.loaderStatus(true);
      dispatch(setStramState("ended"));
      callEndStreamAPI()
        .then((resp) => {
          callEvent([{
            "event_data":
            {"client_id":resp1["owner"]['client_id'],
              "stream_id":resp1["stream_id"],
              "stream_instance_id":resp1["stream_instance_id"],
              "user_id":resp1["owner"]['client_id'],
              // "elapsed_seconds":"0",
              "date":new Date().toUTCString()},
            "event_type":"stream_ended"}
          ]);
          props.loaderStatus(false);
          setIsGoLive(false);
          setIsEndStream(false);
          navigate({ screen: screens.public.endLive });
          setTimeout(() => {
            window.location.reload();
          }, 100);
        })
        .catch((err) => {
          props.loaderStatus(false);
         // console.log("streamData====>Err", err);
        });
    } else {
      dispatch(setStramState("ended"));
      navigate({ screen: "/" });
      setTimeout(() => {
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }, 500);
    }
  };

  useEffect(() => {
    if (!props.isHostvalue) {
      setIsGoLive(true);
    }
  }, []);

  useEffect(() => {
    if (streamState == "ending") {
      setTimeout(() => {
        handleEndStream();
       },1000);
    } else if (streamState == "hostEnding") {
      setIsEndStreamHost(true);
    }
  }, [streamState]);

  useEffect(() => {
    props.handleGoLiveChange(isGoLive);
  }, [isGoLive]);

  useEffect(() => {
    if (streamState === "started" && !isGoLive) {
      setIsGoLive(true);
    }
  }, [streamState, isGoLive]);

  useEffect(() => {
    const isStreamStarted = isGoLive || streamState === "started";
    if (!isStreamStarted) {
      setTime(0);
      return;
    }
    var offset = 0;
    if (isHost()) {
      dispatch(setHostTime(Date.now() * 1000));
    } else {
      return;
    }
    const interval = setInterval(() => {
      setTime((prevTime) => {
        if ((prevTime + 2) / 60 > (publicUserData?.max_meeting_length ? publicUserData?.max_meeting_length : 25)) {
          dispatch(setStramState('ending'));
          setTimeout(() => {
            dispatch(turnOffScreenSharing());
           },100);
        }
        return prevTime + 1
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [isGoLive, streamState]);

  useEffect(() => {
    const isStreamStarted = isGoLive || streamState === "started";
    if (!isStreamStarted) {
      setTime(0);
      return;
    }
    var offset = 0;
    if (isHost()) {
      return;
    } else {
      offset = Math.floor((Date.now() * 1000 - hostTime) / 1000000);
      setTime(offset);
    }
    const interval = setInterval(() => {
      setTime((prevTime) => {
        return prevTime + 1;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [hostTime, isGoLive, streamState]);

  useEffect(() => {
    dispatch(setHostSeconds(time));
  },[time])

  useEffect(() => {
    if (!props.isHostvalue) {
      setIsGoLive(true);
    }
  }, [props.isHostvalue]);
  return (
    <>
      <div style={{ zIndex: 0, pointerEvents: "none" }}>
        <div
          className="w-full flex justify-between pl-4 pr-4 pt-4 items-center"
          style={{ pointerEvents: "none" }}
        >
          <div style={{ pointerEvents: "auto" }}>
            {(isGoLive || streamState === "started") && (
              <div className="flex">
                <div className="flex rounded-full bg-[#202121]/[0.4] ">
                  <div
                    className="bg-[#DA414A] h-full rounded-l-full pl-3 pr-3 pt-3 pb-3 cursor-pointer"
                    onClick={() => {
                      //   setIsGoLive(false)
                      setIsEndStream(true);
                      props.closeShareSheet();
                    }}
                  >
                    <TfiClose color="#ffffff" size={15} cursor="pointer" />
                  </div>

                  <div className="bg-[#202121]/[0.4] rounded-r-full pl-3 pr-3 flex items-center justify-center">
                    <span className="text-white">{formatTime(time)}</span>
                  </div>
                </div>

                {/* {showAttendeeCount && isHost() && <div className="ml-5 rounded-full bg-[#202121] flex  pl-3 pr-3 items-center justify-center cursor-pointer"
                      onClick={()=>{dispatch(showIsAttendeeList(true))}}>
                          <PiEyeFill color="#ffffff" size={18}></PiEyeFill>
                          <span className="ml-2 text-white"> {personNum} </span>
                      </div>} */}
              </div>
            )}
          </div>

          <div style={{ pointerEvents: "auto", display: "none" }}>
            <div
              id="globalShareActionButton"
              onClick={() => {
                generateDynamicLink();
              }}
              className="h-[45px] w-[45px] bg-[#202121]/[0.5] rounded-full flex items-center justify-center cursor-pointer"
            >
              <RiSendPlaneFill color={"#ffffff"} size={25}></RiSendPlaneFill>
            </div>
          </div>
        </div>
        {linkVisible && (
          <div
            className="w-full flex pl-4 pr-4 pt-4 items-center"
            style={{ pointerEvents: "auto" }}
          >
            <div onClick={handleCopy}>
              <span
                style={{}}
                className="text-white bg-[#202121] rounded-full pl-5 pr-5 pt-2 pb-2 cursor-pointer"
              >
                {dnLink}
              </span>
            </div>
          </div>
        )}
        {isEndStream && (
          <div style={{ pointerEvents: "auto" }}>
          <EndStreamModal
            modalIsOpen={isEndStream}
            handleClickOnNo={() => {
              setIsEndStream(false);
            }}
            handleClickOnyes={() => {
              if(!isHost())
              {
                window.location.reload();
                return;
              }
              dispatch(setStramState('ending'));
              if (isRecord) {
                stopRecordAPI()
                  .then((res) => {
                    dispatch(stopRecordingData(res));
                    setTimeout(() => {
                      dispatch(turnOffScreenSharing());
                    },100);
                  })
                  .catch((error) => {
                    console.error("Error stopRecordAPI:", error);
                    setTimeout(() => {
                      dispatch(turnOffScreenSharing());
                    },100);
                  });
        
                dispatch(turnOffRecord());
              } else {
                setTimeout(() => {
                  dispatch(turnOffScreenSharing());
                },100);
              }
            }}
          ></EndStreamModal>
          </div>
        )}
        {(isEndStreamHost && !isHost()) && (
          <div style={{ pointerEvents: "auto" }}>
          <EndStreamModalHost
            modalIsOpen={isEndStreamHost}
            handleClickOnNo={() => {
              setIsEndStreamHost(false);
              setTimeout(() => {
                window.location.reload();
              },100);
            }}
            handleClickOnyes={() => {
              setIsEndStreamHost(false);
              window.history.back();
              setTimeout(() => {
                window.location.reload();
              },100);
            }}
          />
          </div>
        )}
      </div>
    </>
  );
};

export default HeaderControls;
